module.exports = __webpack_public_path__ + "img/A61-20190408_05.32e555ce.jpg";